import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function SlabPhoto({ src, alt = "MAS graded slab", tilt = true, className = "" }) {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rx = useSpring(useTransform(my, [0, 1], [7, -7]), { stiffness: 150, damping: 18 });
  const ry = useSpring(useTransform(mx, [0, 1], [-7, 7]), { stiffness: 150, damping: 18 });
  const glareX = useTransform(mx, [0, 1], ["0%", "100%"]);
  const glareBg = useTransform(glareX, (v) => `radial-gradient(circle at ${v} 10%, rgba(255,255,255,0.4), transparent 45%)`);

  const onMove = (e) => {
    if (!tilt || !ref.current) return;
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };
  const onLeave = () => { mx.set(0.5); my.set(0.5); };

  return (
    <div className={`[perspective:1300px] ${className}`}>
      <motion.div
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        style={tilt ? { rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" } : {}}
        className="relative rounded-[22px] overflow-hidden bg-neutral-100 shadow-[0_35px_70px_-25px_rgba(0,0,0,0.5)] ring-1 ring-black/5"
        data-testid="slab-photo"
      >
        <img src={src} alt={alt} className="block w-full h-full object-contain select-none pointer-events-none" draggable={false} />
        {tilt && <motion.div className="pointer-events-none absolute inset-0 mix-blend-overlay" style={{ background: glareBg }} />}
      </motion.div>
    </div>
  );
}
